<template>
  <div class="box" :class="box_cls">
    <div class="header" v-if="label" @click.stop="headerToggleOpen()" :class="{'togglable':(headerToggle != undefined)}">
		  {{label}}
      <div class="toggler" v-if="is_open==true || is_open==false" :class="{open:(is_open===true)}" @click="togglerToggleOpen()">
        <svgicon icon="ionicons/chevron-right"></svgicon>
      </div>
      <div class="meta-r" v-if="$slots['meta-r']">
        <slot name="meta-r"></slot>
      </div>
	  </div>
    <div class="content" v-if="is_open === undefined || is_open === true">
		  <slot></slot>
	  </div>
  </div>
</template>

<script>
import Btn from './../components/Btn'
import './../components/generated_svg_icons/ionicons/chevron-right'
export default {
  components: { Btn },
  props: [ 'label', 'open', 'header-toggle','cls' ],
  data: function () {
    return {
      is_open: undefined,
    }
  },
  computed:{
    
    box_cls(){
      var output = ''
      if(this.cls) output += this.cls
      //if( this._props.w != undefined ) output += 'w'+this._props.w
      return output
    },

  },
  methods: {
    
    toggleOpen(){
      if( this._events['toggledOpen'] ) {
        this.$emit('toggledOpen', !this.is_open )
      } else {
        if( this.is_open === undefined ) this.is_open = true
        this.is_open = !this.is_open        
      }
    },
    
    headerToggleOpen(){
      if( this._props.headerToggle != undefined ) this.toggleOpen()
    },
    
    togglerToggleOpen(){
      if( this._props.headerToggle == undefined ) this.toggleOpen()
    },

  },
  created(){
    if(this.open) this.is_open = this.open
  },
}
</script>



// WEBPACK FOOTER //
// Box.vue?cbe59440